import React, { useEffect, useState } from "react";
import { Icons } from "../../atoms/Icons";
import "./boostyoursavingsmodal.scss";
import CustomizedSwitches from "../../atoms/Switch";
import { Col, Row } from "react-bootstrap";
import { BoostYourSavingsCard } from "../BoostYourSavingsCard";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import DetailsComp from "./DetailsComp";
import Buttons from "../../atoms/Buttons";
import { livingStandardData } from "../../helpers/helpers";
import { actionCreators } from "../../redux/actions";
const BoostYourSavingsModal = (props) => {
  const [cardName, setCardName] = useState("");
  const [back, setBack] = useState(false);
  const [switched, setSwitched] = useState(false);
  const [singleCouple, setSingleCouple] = useState([]);
  // eslint-disable-next-line
  const { fetching, data, error } = useSelector(
    (state) => state.livingStandards, // eslint-disable-line
  );
  const dispatch = useDispatch();
  const { getLivingStandards } = bindActionCreators(
    actionCreators,
    dispatch, // eslint-disable-line
  );
  useEffect(() => {
    if (Object.keys(data).length === 0) {
      getLivingStandards(props.investorId);
    }
  }, []);
  useEffect(() => {
    if (!switched) {
      setSingleCouple(
        livingStandardData(data?.properties?.livingStandardsSingle?.items), //eslint-disable-line
      );
    } else {
      setSingleCouple(
        livingStandardData(data?.properties?.livingStandardsCouple?.items), //eslint-disable-line
      );
    }
  }, [data]);
  const handleCardClick = (item, backBtn) => {
    if (backBtn) {
      setCardName("");
      setBack(false);
    } else {
      setBack(true);
      setCardName(item.title);
    }
  };
  const handleSwitch = (e) => {
    if (!e.target.checked) {
      setSingleCouple(
        livingStandardData(data?.properties?.livingStandardsSingle?.items), //eslint-disable-line
      );
    } else {
      setSingleCouple(
        livingStandardData(data?.properties?.livingStandardsCouple?.items), //eslint-disable-line
      );
    }
    setSwitched(!switched);
  };
  return (
    <div className="boost-savings-modal-container">
      <div className="boost-savings-close">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <p className="title text-center">{props.modalTitle}</p>
      <p className="text-center description mb-4">{props.description}</p>
      <CustomizedSwitches
        checked={switched}
        onChange={handleSwitch}
        label1="Single"
        label2="Two person"
      />
      <Row className="retirement-standards mt-4 g-2">
        {cardName != "" && cardName === "Minimum" ? (
          <>
            <Col lg={4}>
              <BoostYourSavingsCard
                headIconName={singleCouple[0]?.iconName}
                title={singleCouple[0]?.title}
                headIconVariant="icon-fourty-eight-px"
                subTitle={singleCouple[0]?.description}
                value={singleCouple[0]?.value}
                cardData={singleCouple[0]}
                btnName={back}
                onClickHandler={handleCardClick}
              />
            </Col>
            <Col lg={8}>
              <DetailsComp data={singleCouple} itemIndex={0} />
            </Col>
          </>
        ) : cardName != "" && cardName === "Moderate" ? (
          <>
            <Col lg={4}>
              <BoostYourSavingsCard
                headIconName={singleCouple[1]?.iconName}
                title={singleCouple[1]?.title}
                headIconVariant="icon-fourty-eight-px"
                subTitle={singleCouple[1]?.description}
                value={singleCouple[1]?.value}
                cardData={singleCouple[1]}
                btnName={back}
                onClickHandler={handleCardClick}
              />
            </Col>
            <Col lg={8}>
              <DetailsComp data={singleCouple} itemIndex={1} />
            </Col>
          </>
        ) : cardName != "" && cardName === "Comfortable" ? (
          <>
            <Col lg={4}>
              <BoostYourSavingsCard
                headIconName={singleCouple[2]?.iconName}
                title={singleCouple[2]?.title}
                headIconVariant="icon-fourty-eight-px"
                subTitle={singleCouple[2]?.description}
                value={singleCouple[2]?.value}
                cardData={singleCouple[2]}
                btnName={back}
                onClickHandler={handleCardClick}
              />
            </Col>
            <Col lg={8}>
              <DetailsComp data={singleCouple} itemIndex={2} />
            </Col>
          </>
        ) : (
          singleCouple?.map((item, index) => {
            return (
              <Col lg={4} key={index}>
                <BoostYourSavingsCard
                  headIconName={item.iconName}
                  title={item.title}
                  headIconVariant="icon-fourty-eight-px"
                  subTitle={item.description}
                  value={item.value}
                  cardData={item}
                  onClickHandler={handleCardClick}
                />
              </Col>
            );
          })
        )}
      </Row>
      <Row className="retirement-standards mt-4">
        <Col className="text-end">
          <Buttons
            name="Got it!"
            className="primary"
            handleClick={props.handleCloseButton}
          />
        </Col>
      </Row>
      <Row className="learn-more">
        <Col xs={8} className="text-start">
          <Buttons
            name="Learn more about the Pensions UK Retirement Living Standards"
            className="tertiary"
            handleClick={() =>
              window.open(
                "https://www.retirementlivingstandards.org.uk/",
                "_blank", //eslint-disable-line
              )
            }
          />
        </Col>
      </Row>
    </div>
  );
};

export default BoostYourSavingsModal;
